import { render } from "./TenantEdit.vue?vue&type=template&id=07da9380"
import script from "./TenantEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./TenantEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Tenant/TenantEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07da9380"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07da9380', __exports__)) {
    api.reload('07da9380', __exports__)
  }
  
  module.hot.accept("./TenantEdit.vue?vue&type=template&id=07da9380", () => {
    api.rerender('07da9380', render)
  })

}


export default __exports__